module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pagina-erro', {
    attrs: {
      "titulo": "Página não encontrada",
      "icone": "fa fa-eye-slash",
      "imagemTexto": "centralservidor-logo-texto.png",
      "imagem": "centralservidor-logo.png",
      "texto": "A página que você esta tentando acessar não foi encontrada.\n\t\tPor favor, verifique o link digitado ou entre em contato\n\t\tcom o administrador."
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7bda3b2","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/nao-encontrado/index.vue
// module id = RxZC
// module chunks = 5